import { useEffect, useState } from 'react';
import Input from '../../../../../../../components/Input';
import { Select } from '../../../../../../../components/Select';
import { ActionIcon, Select as MantineSelect, Popover } from '@mantine/core';
import { FormElement, SelectWrapper, TableBody, TableHeader } from '../../style';
import classNames from 'classnames';
import Checkbox from '../../../../../../../components/Checkbox';
import EsmaBaseCurrencyField from './ESMABaseCurrencyField';
import { Button, Flex, Box } from '@mantine/core';
import { TbTrash } from 'react-icons/tb';
import { REPORT_NAMINGS, REPORT_TYPES } from '../../../../../../../consts/reportTypes';
import {
  JURISDICTION_MASTER_STATUS_KEYS,
  jurisdictionsMasterStatusList
} from '../../../../../../../consts/jurisdictions';
import { IoIosArrowDown } from 'react-icons/io';
import { CustomMultiSelect } from '../CustomMultiSelect';
import { DeleteConfirmModal } from '../../../../../../../components/DeleteConfirmModal';
import { useDeleteCustomMasterFund } from '../../../../../../../services/jurisdiction.service';
import toast from 'react-hot-toast';
import CustomMasterFundNameInput from '../CustomMasterFundNameInput';
import { BiDotsVertical } from 'react-icons/bi';
import { PermissionGuard, DENY_REASONS } from '../../../../../../../components/PermissionGuard';
import { extractApiError } from '../../../../../../../utils';

export const DeleteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.72386 1.7239C5.97391 1.47385 6.31304 1.33337 6.66667 1.33337H9.33333C9.68696 1.33337 10.0261 1.47385 10.2761 1.7239C10.5262 1.97395 10.6667 2.31309 10.6667 2.66671V4.00004H12.6589C12.6636 3.99999 12.6683 3.99999 12.673 4.00004H13.3333C13.7015 4.00004 14 4.29852 14 4.66671C14 5.0349 13.7015 5.33337 13.3333 5.33337H13.2801L12.6664 12.6972C12.6585 13.2166 12.4488 13.713 12.0809 14.0809C11.7058 14.456 11.1971 14.6667 10.6667 14.6667H5.33333C4.8029 14.6667 4.29419 14.456 3.91912 14.0809C3.55125 13.713 3.34148 13.2166 3.33357 12.6972L2.71991 5.33337H2.66667C2.29848 5.33337 2 5.0349 2 4.66671C2 4.29852 2.29848 4.00004 2.66667 4.00004H3.32702C3.33174 3.99999 3.33644 3.99999 3.34113 4.00004H5.33333V2.66671C5.33333 2.31309 5.47381 1.97395 5.72386 1.7239ZM4.05787 5.33337L4.66436 12.6113C4.6659 12.6298 4.66667 12.6482 4.66667 12.6667C4.66667 12.8435 4.7369 13.0131 4.86193 13.1381C4.98695 13.2631 5.15652 13.3334 5.33333 13.3334H10.6667C10.8435 13.3334 11.013 13.2631 11.1381 13.1381C11.2631 13.0131 11.3333 12.8435 11.3333 12.6667C11.3333 12.6482 11.3341 12.6298 11.3356 12.6113L11.9421 5.33337H4.05787ZM9.33333 4.00004H6.66667V2.66671H9.33333V4.00004ZM6.66667 6.66671C7.03486 6.66671 7.33333 6.96518 7.33333 7.33337V11.3334C7.33333 11.7016 7.03486 12 6.66667 12C6.29848 12 6 11.7016 6 11.3334V7.33337C6 6.96518 6.29848 6.66671 6.66667 6.66671ZM9.33333 6.66671C9.70152 6.66671 10 6.96518 10 7.33337V11.3334C10 11.7016 9.70152 12 9.33333 12C8.96514 12 8.66667 11.7016 8.66667 11.3334V7.33337C8.66667 6.96518 8.96514 6.66671 9.33333 6.66671Z"
      fill="#FA5252"
    />
  </svg>
);

const ADD_OPTION = { add_option: true, label: '', value: '' };

export const ESMAJurisdiction = ({
  funds,
  country,
  aifmCode,
  countries,
  generatedId,
  reportType,
  periodId,
  workflowId,
  forceExpand,
  fundsOptions,
  deleteDisabled,
  jurisdictionId,
  toggleIncluded,
  aifUniqueIssues = [],
  aifmUniqueIssues = [],
  closeForceExpand,
  jurisdictionIndex,
  toggleLastReporting,
  handleChangeCountry,
  handleChangeAIFCode,
  handleBaseCurrencyChange,
  handleChangeAIFMCode,
  deletingJurisdictionId,
  handleDeleteJurisdiction,
  onCreateCustomMasterFund,
  refetchCustomMasterFunds,
  handleToggleNilReturn,
  handleChangeMasterFundId,
  handleChangeMasterFeederStatus,
  onDeleteCustomMasterFund,
  canManageWorkflow = true,
  isLockedPeriod = false
}) => {
  const [showMore, setShowMore] = useState(false);
  const [deletableCustomMasterFund, setDeletableCustomMasterFund] = useState(null);
  const allowed = canManageWorkflow && !isLockedPeriod;
  const denyReason = isLockedPeriod ? DENY_REASONS.LOCKED_PERIOD : DENY_REASONS.NO_PERMISSION;

  const selectedCountry =
    typeof country === 'object'
      ? country
      : country
        ? countries?.find(cntry => cntry.reporting_member_state === country)
        : null;

  const isUK = selectedCountry?.reporting_member_state === 'UK';

  useEffect(() => {
    if (forceExpand) {
      setShowMore(true);
      closeForceExpand();
    }
  }, [forceExpand]);

  const deleteCustomMasterFunds = useDeleteCustomMasterFund({ workflowId });

  const onDeleteConfirm = () => {
    if (!deletableCustomMasterFund) return;

    deleteCustomMasterFunds.mutate(deletableCustomMasterFund.key, {
      onSuccess: () => {
        setDeletableCustomMasterFund(null);
        onDeleteCustomMasterFund(deletableCustomMasterFund.key);
      },
      onError: err => {
        console.error('Error deleting Custom Master Fund:', err);
        toast.error(extractApiError(err, 'Unable to delete this custom master fund.'));
      }
    });
  };

  const masterFundsIds =
    funds
      ?.filter(fund => fund.masterFeederStatus === JURISDICTION_MASTER_STATUS_KEYS.MASTER)
      ?.map(fund => fund.key) || [];

  return (
    <>
      <Box
        w="100%"
        sx={() => ({
          border: '1px solid #f1f3f5'
        })}
        component="table"
        id={generatedId}
      >
        <TableHeader>
          <tr>
            <th>
              <div className="regulator">
                <span>Regulator</span>
                <span className="count">{funds?.length} funds</span>
              </div>
            </th>
            <th>National Codes</th>

            <th className="base-currency-heading">Base Currency</th>
            <th>Nil Return</th>
            <th>
              <div className="reporting">Final Reporting</div>
            </th>
            <th>Type</th>
            <th>Master Fund</th>
            <th>Actions</th>
          </tr>
        </TableHeader>
        <TableBody>
          <tr>
            <td className="regulator">
              <SelectWrapper>
                <div className="select">
                  <Select
                    id={`select-${generatedId}`}
                    value={selectedCountry}
                    isSearchable
                    placeholder="Select Jurisdiction Country"
                    options={[{ country_name: 'None', reporting_member_state: null }, ...countries]}
                    getOptionValue={opt => opt.reporting_member_state}
                    getOptionLabel={opt => opt.country_name}
                    onChange={handleChangeCountry}
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    required
                    isDisabled={!allowed}
                    styles={{
                      singleValue: baseStyles => ({
                        ...baseStyles,
                        textTransform: 'uppercase'
                      }),
                      option: baseStyles => ({
                        ...baseStyles,
                        textTransform: 'uppercase'
                      })
                    }}
                  />
                </div>
              </SelectWrapper>
            </td>
            <td>
              <div className="elements">
                <FormElement>
                  {isUK ? (
                    <Input
                      required
                      value={aifmCode}
                      inputId={`input-${generatedId}`}
                      onChange={e => handleChangeAIFMCode(e.target.value, jurisdictionIndex)}
                      boxClass={classNames('input', {
                        error: aifmUniqueIssues.includes(generatedId)
                      })}
                      placeholder={`Enter ${REPORT_NAMINGS.PROJECT?.[reportType]} Code`}
                      minLength={6}
                      maxLength={7}
                      disabled={!allowed}
                    />
                  ) : (
                    <Input
                      required
                      autoFocus
                      value={aifmCode}
                      inputId={`input-${generatedId}`}
                      onChange={e => handleChangeAIFMCode(e.target.value, jurisdictionIndex)}
                      boxClass={classNames('input', {
                        error: aifmUniqueIssues.includes(generatedId)
                      })}
                      placeholder={`Enter ${REPORT_NAMINGS.PROJECT?.[reportType]} Code`}
                      minLength={1}
                      maxLength={30}
                      disabled={!allowed}
                    />
                  )}
                </FormElement>
              </div>
            </td>
            <td>
              <div className="elements"></div>
            </td>
            <td>
              <div className="elements">
                <FormElement>
                  <div style={{ display: 'flex' }}></div>
                </FormElement>
              </div>
            </td>
            <td>
              <div className="elements"></div>
            </td>
            <td>
              <div className="elements"></div>
            </td>
          </tr>

          {(!showMore && funds.length > 6 ? funds.slice(0, 2) : funds)?.map(fund => {
            const filteredFunds = fundsOptions?.filter(
              fd => (fd.id !== fund?.key && masterFundsIds?.includes(fd?.id)) || !!fd?.isMasterFund
            );

            const mutatedFunds = filteredFunds?.map(el => ({ value: el.id, label: el.name })) || [];
            const disabledMultiSelect =
              fund.masterFeederStatus === JURISDICTION_MASTER_STATUS_KEYS.MASTER ||
              fund.masterFeederStatus === JURISDICTION_MASTER_STATUS_KEYS.NONE ||
              !fund.masterFeederStatus;

            const errorMultiSelect =
              fund.isIncluded &&
              fund.masterFeederStatus === JURISDICTION_MASTER_STATUS_KEYS.FEEDER &&
              (!fund.masterFundIds || fund.masterFundIds?.length === 0) &&
              'Master Fund is required';

            return (
              <tr key={generatedId + fund.key}>
                <td className={!fund.isIncluded && 'not_included'}>
                  <div className="label">
                    <Checkbox
                      onChange={() => toggleIncluded(!fund.isIncluded, fund.key, jurisdictionIndex)}
                      checked={fund.isIncluded}
                      disabled={fund.isCustomMasterFund || !allowed}
                      className="checkbox"
                    />

                    {fund?.isCustomMasterFund ? (
                      <CustomMasterFundNameInput
                        key={fund.name}
                        initialValue={fund.name}
                        onChange={refetchCustomMasterFunds}
                        workflowId={workflowId}
                        masterFundId={fund.key}
                        disabled={!allowed}
                      />
                    ) : (
                      fund.name
                    )}
                  </div>
                </td>
                <td className={!fund.isIncluded && 'not_included'}>
                  <div className="elements">
                    <FormElement>
                      {isUK ? (
                        <Input
                          inputId={`${generatedId}-${fund.key}`}
                          required={fund.isIncluded && !fund.isCustomMasterFund}
                          value={fund.code}
                          onChange={e =>
                            handleChangeAIFCode(e.target.value, fund.key, jurisdictionIndex)
                          }
                          boxClass={classNames('input', {
                            error: aifUniqueIssues.includes(`${generatedId}-${fund.key}`)
                          })}
                          placeholder={`Enter ${REPORT_NAMINGS.FUND?.[reportType]} Code`}
                          minLength={6}
                          maxLength={7}
                          autoFocus
                          disabled={!allowed}
                        />
                      ) : (
                        <Input
                          required={fund.isIncluded && !fund.isCustomMasterFund}
                          inputId={`${generatedId}-${fund.key}`}
                          value={fund.code}
                          onChange={e =>
                            handleChangeAIFCode(e.target.value, fund.key, jurisdictionIndex)
                          }
                          boxClass={classNames('input', {
                            error: aifUniqueIssues.includes(`${generatedId}-${fund.key}`)
                          })}
                          placeholder={`Enter ${REPORT_NAMINGS.FUND?.[reportType]} Code`}
                          minLength={1}
                          maxLength={30}
                          autoFocus
                          disabled={!allowed}
                        />
                      )}
                    </FormElement>
                  </div>
                </td>

                <td className={!fund.isIncluded && 'not_included'}>
                  {!fund?.isCustomMasterFund && (
                    <EsmaBaseCurrencyField
                      fund={fund}
                      disabled={reportType === REPORT_TYPES.CONVERSION || !allowed}
                      onChange={valueObject =>
                        handleBaseCurrencyChange(valueObject?.value, fund.key, jurisdictionIndex)
                      }
                    />
                  )}
                </td>
                <td className={!fund.isIncluded && 'not_included'}>
                  {!fund?.isCustomMasterFund && (
                    <div className="reporting">
                      <Checkbox
                        onChange={() =>
                          handleToggleNilReturn(
                            !fund.aifNoReportingFlag,
                            fund.key,
                            jurisdictionIndex
                          )
                        }
                        checked={fund.aifNoReportingFlag}
                        disabled={!allowed}
                      />
                    </div>
                  )}
                </td>

                <td className={!fund.isIncluded && 'not_included'}>
                  {!fund?.isCustomMasterFund && (
                    <div className="reporting">
                      <Checkbox
                        onChange={() =>
                          toggleLastReporting(!fund.isLastReporting, fund.key, jurisdictionIndex)
                        }
                        checked={fund.isLastReporting}
                        disabled={!allowed}
                      />
                    </div>
                  )}
                </td>

                <td className={!fund.isIncluded && 'not_included'}>
                  {!fund?.isCustomMasterFund && (
                    <div className="reporting">
                      <MantineSelect
                        w="100%"
                        placeholder="Select"
                        rightSection={<IoIosArrowDown />}
                        data={jurisdictionsMasterStatusList}
                        value={fund.masterFeederStatus}
                        disabled={!allowed}
                        onChange={e =>
                          handleChangeMasterFeederStatus(e, fund.key, jurisdictionIndex)
                        }
                      />
                    </div>
                  )}
                </td>

                <td className={!fund.isIncluded && 'not_included'}>
                  {!fund?.isCustomMasterFund && (
                    <div className="reporting">
                      <CustomMultiSelect
                        periodId={periodId}
                        workflowId={workflowId}
                        rightSection={<IoIosArrowDown />}
                        disabled={disabledMultiSelect || !allowed}
                        data={[{ ...ADD_OPTION }, ...mutatedFunds]}
                        placeholder="Select"
                        searchable={true}
                        value={fund.masterFundIds ? fund.masterFundIds : []}
                        multiple={true}
                        w={220}
                        error={errorMultiSelect}
                        maw={220}
                        onSelectCustomMasterFund={val => onCreateCustomMasterFund(fund.key, val)}
                        onChange={e =>
                          handleChangeMasterFundId(
                            e.filter(el => el),
                            fund.key,
                            jurisdictionIndex
                          )
                        }
                      />
                    </div>
                  )}
                </td>

                <td className={!fund.isIncluded && 'not_included'}>
                  {fund?.isCustomMasterFund && (
                    <div className="reporting">
                      <Popover width={200} position="bottom" withArrow shadow="md">
                        <Popover.Target>
                          <ActionIcon variant="transparent">
                            <BiDotsVertical />
                          </ActionIcon>
                        </Popover.Target>
                        <Popover.Dropdown w={130}>
                          <PermissionGuard allowed={allowed} reason={denyReason}>
                            <Button
                              variant="subtle"
                              leftSection={<DeleteIcon />}
                              color="red.8"
                              onClick={() => setDeletableCustomMasterFund(fund)}
                            >
                              Delete
                            </Button>
                          </PermissionGuard>
                        </Popover.Dropdown>
                      </Popover>
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </TableBody>
      </Box>

      <Flex mb="20px" mt="8" justify="space-between">
        {funds.length > 6 ? (
          showMore ? (
            <Button
              size="sm"
              variant="white"
              type="button"
              onClick={() => setShowMore(prev => !prev)}
            >
              Hide ({funds.length - 2})
            </Button>
          ) : (
            <Button
              size="sm"
              variant="white"
              type="button"
              onClick={() => setShowMore(prev => !prev)}
            >
              See More ({funds.length - 2})
            </Button>
          )
        ) : (
          <div />
        )}

        <PermissionGuard allowed={allowed} reason={denyReason}>
          <Button
            size="sm"
            variant="white"
            type="button"
            color="red"
            disabled={deleteDisabled}
            onClick={handleDeleteJurisdiction}
            loading={jurisdictionId === deletingJurisdictionId}
            leftSection={<TbTrash />}
            data-testid={`delete-${jurisdictionId}`}
          >
            Delete
          </Button>
        </PermissionGuard>
      </Flex>

      <DeleteConfirmModal
        zIndex={10000}
        isOpen={!!deletableCustomMasterFund}
        onClose={() => setDeletableCustomMasterFund(null)}
        onConfirm={onDeleteConfirm}
        isLoading={deleteCustomMasterFunds.isLoading}
        submitLabel="Yes, Delete"
        title="Delete Custom Master Fund"
        description={`Are you sure you want to delete "${deletableCustomMasterFund?.name}"? This action cannot be undone.`}
      />
    </>
  );
};
